import React from "react";

export default function Loader({ wrapCname }: { wrapCname?: string }) {
    return (
        <div className={wrapCname || "content-center"}>
            <div className="lds-ellipsis content-center--item">
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
}
